import React, { useEffect, useState } from "react";
import "./style.scss";
import { IoIosCloseCircle, IoMdClose } from "react-icons/io";
import { Box, Button, Rating } from "@mui/material"
import Swal from "sweetalert2";
import { PacmanLoader } from "react-spinners";
import Multiselect from "multiselect-react-dropdown";
import { addAdmin, getAllPermissions, updatePermission } from "services/admin/adminService";


const ModalAdminManage = ({ admin, onClose  }) => {
    const token = localStorage.getItem("token")
    const [isLoading, setIsLoading] = useState(false)
    const [modal, setModal] = useState(true);
    const toggleModal = () => {
        setModal(!modal)
    }

    const [selectPermission, setSelectedPermission] = useState([])

    const [fullName, setFullName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [permissions, setPermissions] = useState([]);
    const [error, setError] = useState({fullNameError: '', phoneNumberError: ''});

    const handleNameChange = (event) => {
        setFullName(event.target.value);
    };
    const handlePhoneChange = (event) => {
        setPhoneNumber(event.target.value);
    };

    const validateFullName = () => {
        const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/; // Kiểm tra kí tự đặc biệt
        const numberRegex = /\d/; // Kiểm tra có số k
      
        if (!fullName) {
            setError((prevError) => ({
                ...prevError,
                fullNameError: 'Họ và tên không được để trống',
            }));
        } 
        else if (specialCharRegex.test(fullName)) {
            setError((prevError) => ({
                ...prevError,
                fullNameError: 'Họ và tên không được chứa kí tự đặc biệt',
            }));
        } 
        else if (numberRegex.test(fullName)) {
            setError((prevError) => ({
                ...prevError,
                fullNameError: 'Họ và tên không được chứa số',
            }));
        } 
        else {
            setError((prevError) => ({
                ...prevError,
                fullNameError: '',
            }));
        }
    };

     useEffect(() => {
        const fetchPermissions = async() => {
            // setIsLoading(true);
            try {
                const response = await getAllPermissions(token);
                setPermissions(response.data);
            } 
            catch (error) {
                console.error("Error fetching permissions:", error);
            }
            // finally {
            //     setIsLoading(false);
            // }
        };

        fetchPermissions();
    },[token])
      
    const validatePhoneNumber = () => {
        const phoneRegex = /^0\d{9}$/;
        // if (!phoneNumber) {
        //     setError((prevError) => ({
        //         ...prevError,
        //         phoneNumberError: 'Số điện thoại không được để trống',
        //     }));
        // } 
        if (!phoneRegex.test(phoneNumber)) {
            setError((prevError) => ({
                ...prevError,
                phoneNumberError: 'Số điện thoại phải bắt đầu bằng 0 và có 10 chữ số',
            }));
        } 
        else {
            setError((prevError) => ({
                ...prevError,
                phoneNumberError: '',
            }));
        }
    };

    const handleSelect = (selectedList) => {
        console.log(selectedList)
        setSelectedPermission(selectedList.map((item) => item.id))
    };
    
    const handleRemove = (selectedList) => {
        setSelectedPermission(selectedList.map((item) => item.id))
    };
    console.log(selectPermission);

    const handleAddAdmin = async () => { 
        const adminData = {
            fullName: fullName,
            phoneNumber: phoneNumber,
            permissionIDs: selectPermission
        }
        try {
            setIsLoading(true);
            const response = await addAdmin(token, adminData);
            if (response.status === 200) {
                Swal.fire({
                    title: "Thêm admin thành công!",
                    text: `Admin đã được thêm mới`,
                    icon: "success"
                });
                onClose(true);
            } 
            else {
                Swal.fire({
                    title: "Thêm admin thất bại!",
                    text: `Vui lòng thử lại sau!`,
                    icon: "error"
                });
            }
        }
        catch (error) {
            console.log("Error adding admin:", error);
            Swal.fire({
                title: "Thêm admin thất bại!",
                text: `Vui lòng thử lại sau!`,
                icon: "error"
            });
        }
        finally {
            setIsLoading(false);
        }
    }

    const handleEditAdmin = async () => { 
        const adminData = {
            email: admin.email,
            permissionIDs: selectPermission
        }
        try {
            setIsLoading(true);
            const response = await updatePermission(token, adminData);
            if (response.status === 200) {
                Swal.fire({
                    title: "Cập nhật quyền admin thành công!",
                    text: `Quyền admin đã được cập nhật`,
                    icon: "success"
                });
                onClose(true);
            } 
            else {
                Swal.fire({
                    title: "Cập nhật quyền admin thất bại!",
                    text: `Vui lòng thử lại sau!`,
                    icon: "error"
                });
            }
        }
        catch (error) {
            console.log("updatePermission", error);
            Swal.fire({
                title: "Cập nhật quyền admin thất bại!",
                text: `Vui lòng thử lại sau!`,
                icon: "error"
            });
        }
        finally {
            setIsLoading(false);
        }
    }


    return (
        <div className="modal_admin_manage">
            <div className="overlay_admin_manage">
                <div className="modal-content_admin_manage">
                <div
                    className="d-flex"
                    style={{
                        background: '#9d2ff7',
                        height: '50px',
                        margin: '-15px -28px 14px',
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                        position: 'relative', 
                        zIndex: 1,
                    }}
                >
                    <h5
                        className="w-100"
                        style={{
                            position: 'absolute',
                            color: 'white',
                            fontSize: '18px',
                            top: '50%',
                            left: '28px',    
                            transform: 'translateY(-50%)', 
                            margin: 0, 
                            zIndex: 10,
                        }}
                    >
                        {!admin ? 'Thêm mới admin' : 'Chỉnh sửa thông tin admin'}
                    </h5>
                    <IoMdClose
                        className="close-modal ms-auto"
                        style={{
                            position: 'absolute',
                            top: '50%',
                            right: '28px',
                            transform: 'translateY(-50%)',
                            zIndex: 10,
                            cursor: 'pointer',
                        }}
                        onClick={() => onClose(false)}
                    />
                    </div>
                    
                    <div className="">
                        <h4 className="mt-4">Họ và tên</h4>
                        <input 
                            className="personal_infos"
                            type="text"
                            value={admin ? admin.fullName : fullName}
                            onChange={admin ? null : handleNameChange}
                            onBlur={validateFullName}
                            placeholder="Nhập họ và tên" 
                            disabled={admin ? true : false}
                        />
                        <br />
                        {error.fullNameError && <span style={{fontSize: '13px', color: 'red' }}>{error.fullNameError}</span>}

                        {admin && (
                            <>
                                <h4 className="mt-3">Email</h4>
                                <input 
                                    className="personal_infos"
                                    type="text"
                                    value={admin.email}
                                    disabled={admin ? true : false}
                                />
                            </>
                        )}

                        <h4 className="mt-3">Số điện thoại</h4>
                        <input 
                            className="personal_infos"
                            type="text"
                            value={admin ? admin.phoneNumber : phoneNumber}
                            onChange={admin ? null : handlePhoneChange}
                            onBlur={validatePhoneNumber}
                            placeholder= {admin ? '' : "Nhập số điện thoại"}
                            disabled={admin ? true : false}
                        />
                        <br />
                        {error.phoneNumberError && <span style={{fontSize: '13px', color: 'red' }}>{error.phoneNumberError}</span>}

                        <h4 className="mt-3">Quyền quản lí</h4>
                        <Multiselect
                            isObject={true}
                            placeholder="Chọn quyền"
                            emptyRecordMsg="Không tìm thấy" 
                            onKeyPressFn={function noRefCheck(){}}
                            onSearch={function noRefCheck(){}}

                            onSelect={handleSelect}
                            onRemove={handleRemove}
                            options={permissions} // data ở đây nè
                            displayValue="desc" // hiển thị các desc
                            selectedValues={admin ? admin.permissions : []}
                            style={{
                                chips: { background: '#9d2ff7', color: 'white' },
                                optionContainer: {
                                    background: 'white',
                                    maxHeight: '150px',
                                    overflowY: 'auto', 
                                },
                                option: { color: '', fontSize: '14px', padding: '5px' },
                            }}
                        />

                        <Button 
                            className="add-btn ms-auto"
                            onClick={!admin ? handleAddAdmin : handleEditAdmin}
                        >
                            {!admin ? 'Xác nhận thêm' : 'Xác nhận chỉnh sửa'}
                        </Button>
                    </div>
                
                    
                </div>
            </div>
            {isLoading && (
                <div className="modal">
                    <div className="overlay_loading">
                        <div className="modal-content_loading">
                            <div className="d-flex">
                            <PacmanLoader color="#5e2e86"/>
                            </div>
                        </div>
                    </div>
                </div>
            )} 
        </div>
    );
};

export default ModalAdminManage;
